import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6a913807"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "bundle-picker" }
const _hoisted_2 = {
  class: "tabs",
  role: "tablist"
}
const _hoisted_3 = ["aria-selected", "onClick"]
const _hoisted_4 = { class: "cards" }
const _hoisted_5 = ["aria-pressed", "onClick"]
const _hoisted_6 = { class: "price" }
const _hoisted_7 = { class: "text" }
const _hoisted_8 = { class: "name" }
const _hoisted_9 = {
  key: 0,
  class: "details"
}

import { computed, ref, watch } from "vue";

export type Bundle = { id: number; vascoDealDescription: string; name?: string | null; price: number; details?: string | null; category?: string | null };


export default /*#__PURE__*/_defineComponent({
  __name: 'BundlePicker',
  props: {
    bundles: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit }) {

const props = __props;




const order = ["DATA", "LTE", "PACKAGE", "VOICE"];
const labels: Record<string, string> = { DATA: "Data", LTE: "LTE", PACKAGE: "Packages", VOICE: "Voice", OTHER: "Other" };
// Anything not yet given a group still shows, under Other, rather than vanishing.
const keyOf = (b: Bundle) => (order.includes(b.category || "") ? b.category! : "OTHER");

const groups = computed(() =>
  [...order, "OTHER"].map((key) => ({ key, label: labels[key] })).filter((g) => props.bundles.some((b) => keyOf(b) == g.key)));

// What is selected is always on screen: a tab opens with its first bundle chosen, so Process can never buy a
// bundle hidden on another tab. The picker opens on the first group (Data), unless the chosen bundle is pinned
// first, as the current deal is when billing is paused.
const tab = ref("");
// Cheapest first within a group, the current deal (pinned first when billing is paused) kept first.
const shown = computed(() => props.bundles.filter((b) => keyOf(b) == tab.value)
  .sort((a, b) => (a.name?.includes("(your current deal)") ? -1 : b.name?.includes("(your current deal)") ? 1 : a.price - b.price)));
function open(key: string, fresh = false) {
  tab.value = key;
  if ((fresh || !shown.value.some((b) => b.id == props.modelValue)) && shown.value[0]) emit("update:modelValue", shown.value[0].id);
}
// A new list opens on its first group's cheapest bundle, or on the current deal when it is pinned for a paused account.
watch(() => props.bundles, () => {
  const pinned = props.bundles[0]?.name?.includes("(your current deal)");
  open(pinned ? keyOf(props.bundles[0]) : groups.value[0]?.key || "", true);
}, { immediate: true });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(groups.value, (g) => {
        return (_openBlock(), _createElementBlock("button", {
          key: g.key,
          type: "button",
          role: "tab",
          class: _normalizeClass(["tab", { active: g.key == tab.value }]),
          "aria-selected": g.key == tab.value,
          onClick: ($event: any) => (open(g.key))
        }, _toDisplayString(g.label), 11, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(shown.value, (b) => {
        return (_openBlock(), _createElementBlock("button", {
          key: b.id,
          type: "button",
          class: _normalizeClass(["card-option", { selected: b.id == _ctx.modelValue }]),
          "aria-pressed": b.id == _ctx.modelValue,
          onClick: ($event: any) => (emit('update:modelValue', b.id))
        }, [
          _createElementVNode("span", _hoisted_6, "R" + _toDisplayString(Math.round(b.price)), 1),
          _createElementVNode("span", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(b.name || b.vascoDealDescription), 1),
            (b.details)
              ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(b.details), 1))
              : _createCommentVNode("", true)
          ])
        ], 10, _hoisted_5))
      }), 128))
    ])
  ]))
}
}

})